import React from "react";
import { X, Trash2, AlertTriangle, Loader2 } from "lucide-react";

export default function DeleteEstimateConfirmationModal({
  isOpen,
  onClose,
  onConfirm,
  po,
  isDeleting
}) {
  if (!isOpen || !po) return null;

  return (
    <div className="modal-overlay" onClick={isDeleting ? undefined : onClose} style={{ zIndex: 1100 }}>
      <div 
        className="modal-content" 
        onClick={(e) => e.stopPropagation()} 
        style={{ width: "90%", maxWidth: "480px", border: "1px solid rgba(239, 68, 68, 0.3)" }}
      >
        {/* Header */}
        <div className="modal-header" style={{ borderBottom: "1px solid var(--border-color)", paddingBottom: "1rem" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "0.6rem" }}>
            <div style={{ 
              backgroundColor: "rgba(239, 68, 68, 0.15)", 
              color: "var(--danger)", 
              padding: "0.5rem", 
              borderRadius: "8px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}>
              <AlertTriangle size={22} />
            </div>
            <div>
              <h3 style={{ margin: 0, fontSize: "1.15rem", color: "var(--text-primary)" }}>
                Delete Estimate Completely
              </h3>
              <span style={{ fontSize: "0.8rem", color: "var(--text-secondary)" }}>
                Irreversible Action • Manager / Admin Only
              </span>
            </div>
          </div>
          {!isDeleting && (
            <button 
              type="button" 
              className="modal-close-btn" 
              onClick={onClose}
              style={{ background: "none", border: "none", color: "var(--text-secondary)", cursor: "pointer" }}
            >
              <X size={20} />
            </button>
          )}
        </div>

        {/* Modal Body */}
        <div className="modal-body" style={{ padding: "1.25rem 0" }}>
          <p style={{ color: "var(--text-primary)", fontSize: "0.95rem", lineHeight: 1.5, margin: "0 0 1rem 0" }}>
            Are you sure you want to permanently delete estimate <strong>{po.poNumber}</strong>?
          </p>

          <div style={{ 
            backgroundColor: "rgba(255, 255, 255, 0.03)", 
            border: "1px solid var(--border-color)", 
            borderRadius: "6px", 
            padding: "0.85rem 1rem", 
            marginBottom: "1.25rem",
            fontSize: "0.875rem"
          }}>
            <div style={{ display: "grid", gridTemplateColumns: "110px 1fr", rowGap: "0.4rem" }}>
              <span style={{ color: "var(--text-secondary)" }}>EST Number:</span>
              <strong style={{ color: "var(--text-primary)" }}>{po.poNumber}</strong>

              <span style={{ color: "var(--text-secondary)" }}>Client:</span>
              <span style={{ color: "var(--text-primary)", fontWeight: 600 }}>{po.clientName || "N/A"}</span>

              {po.title && (
                <>
                  <span style={{ color: "var(--text-secondary)" }}>Project:</span>
                  <span style={{ color: "var(--text-primary)" }}>{po.title}</span>
                </>
              )}

              <span style={{ color: "var(--text-secondary)" }}>Status:</span>
              <span>
                <span className="badge badge-secondary" style={{ fontSize: "0.75rem" }}>
                  {po.status || "Draft"}
                </span>
              </span>
            </div>
          </div>

          <div style={{ 
            backgroundColor: "rgba(239, 68, 68, 0.08)", 
            border: "1px solid rgba(239, 68, 68, 0.25)", 
            borderRadius: "6px", 
            padding: "0.75rem 1rem",
            color: "#fca5a5",
            fontSize: "0.85rem",
            lineHeight: 1.45
          }}>
            <strong>Warning:</strong> Deleting this estimate will completely purge the record from the database and cascade delete all associated shipments, logistics tracking, inventory linkages, and chat channels.
          </div>
        </div>

        {/* Modal Footer */}
        <div className="modal-footer" style={{ 
          display: "flex", 
          justifyContent: "flex-end", 
          gap: "0.75rem", 
          paddingTop: "1rem", 
          borderTop: "1px solid var(--border-color)" 
        }}>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={onClose}
            disabled={isDeleting}
            style={{ minHeight: "38px" }}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-danger"
            onClick={onConfirm}
            disabled={isDeleting}
            style={{ 
              display: "inline-flex", 
              alignItems: "center", 
              gap: "0.5rem",
              backgroundColor: "var(--danger)",
              borderColor: "var(--danger)",
              color: "#ffffff",
              minHeight: "38px",
              padding: "0.5rem 1.25rem",
              fontWeight: 600,
              cursor: isDeleting ? "not-allowed" : "pointer"
            }}
          >
            {isDeleting ? (
              <>
                <Loader2 size={16} className="spinner-icon animate-spin" />
                Deleting...
              </>
            ) : (
              <>
                <Trash2 size={16} />
                Confirm Delete
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
}
